/** Labels for chat v2 intent-specific confirm documents (.docx preview panel). */

export function resolveConfirmDocType(intent, confirmDocType) {
  if (confirmDocType) return confirmDocType;
  const i = String(intent || 'abap').toLowerCase();
  if (i === 'static_report') return null;
  if (i === 'security' || i === 'sap_auth') return 'auth_acr';
  return 'prd';
}

export function getConfirmDocLabels({ intent, confirmDocType } = {}) {
  const intentNorm = String(intent || 'abap').toLowerCase();
  if (intentNorm === 'static_report') {
    return {
      type: null,
      title: 'Static report',
      shortTitle: 'Report',
      description: 'HTML analytics report for this session.',
      preparing: 'Generating static report…',
      empty: 'Report will appear here when ready.',
      viewButton: 'View report',
      modalTitle: 'Static report',
      modalDescription: 'HTML analytics report for this session.',
      confirmHint: 'Generating your static HTML report — stay on this page.',
    };
  }
  const type = resolveConfirmDocType(intent, confirmDocType);
  if (type === 'auth_acr') {
    return {
      type,
      title: 'Security request',
      shortTitle: 'Security request',
      description: 'Security scope for this chat session — available after confirmation.',
      preparing: 'Preparing security request…',
      empty: 'No security request for this session yet',
      viewButton: 'View security request',
      modalTitle: 'Security request',
      modalDescription: 'Review the security request for this session.',
      confirmHint: 'Optional security request archive — open after the run completes.',
    };
  }
  if (type === 'report_spec') {
    return {
      type,
      title: 'Report specification',
      shortTitle: 'Report spec',
      description: 'Analytics report requirements for this session — available after confirmation.',
      preparing: 'Preparing report specification…',
      empty: 'No report specification for this session yet',
      viewButton: 'View report specification',
      modalTitle: 'Report specification',
      modalDescription: 'Review the HTML report specification for this session.',
      confirmHint: 'Optional report specification — available after the run completes.',
    };
  }
  return {
    type: 'prd',
    title: 'PRD document',
    shortTitle: 'PRD',
    description: 'Product requirements for this chat session — available after confirmation.',
    preparing: 'Preparing PRD…',
    empty: 'No PRD for this session yet',
    viewButton: 'View PRD document',
    modalTitle: 'Product requirements (PRD)',
    modalDescription: 'Review the product requirements document for this session.',
    confirmHint: 'Optional PRD archive — open after ABAP generation completes.',
  };
}

export function confirmDocFilename(sessionId, labels) {
  const sid = String(sessionId || '').slice(0, 8);
  if (labels?.type === 'auth_acr') return `security-request-${sid}.docx`;
  if (labels?.type === 'report_spec') return `report-specification-${sid}.docx`;
  return `requirements-prd-${sid}.docx`;
}
